export var CREATE_PASSWORD = 'CREATE_PASSWORD';
export var SUCCESS_CREATE_PASSWORD = 'SUCCESS_CREATE_PASSWORD';
export var FAILURE_CREATE_PASSWORD = 'FAILURE_CREATE_PASSWORD';



// WEBPACK FOOTER //
// ./src/actions/createPassword.js